import {
  AfterViewChecked,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {Store, select} from '@ngrx/store';
import {Observable, Subscription} from 'rxjs';
import {CartItem} from '../../../../data/model';
import {ContextData} from '../../../context-data';
import {selectContextData} from '../../../context-data/context-data.selectors';
import {BreakpointUtilityService} from '../../../service';
import {
  selectCartItemsForDisplay,
  selectCartSubtotalForDisplay,
} from '../../cart.selectors';

@Component({
  selector: 'app-cart-slide',
  templateUrl: './cart-slide.component.html',
  styleUrls: ['./cart-slide.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CartSlideComponent implements OnInit, OnDestroy, AfterViewChecked {
  @Output() closeCart = new EventEmitter<void>();
  @Output() next = new EventEmitter<void>();
  @Input() useProjection = false;

  cartItems$: Observable<CartItem[]>;
  context$: Observable<ContextData | undefined>;
  cartSubtotal$: Observable<number>;
  cartMessageMapping: {[k: string]: string} = {
    '=0': 'No Items',
    '=1': '1 item',
    other: '# items',
  };
  smallScreen: boolean;
  breakpointSubscription$: Subscription;

  constructor(
    private store: Store,
    protected breakpointUtils: BreakpointUtilityService,
    private ref: ChangeDetectorRef,
  ) {
    this.cartItems$ = this.store.pipe(select(selectCartItemsForDisplay));
    this.cartSubtotal$ = this.store.pipe(select(selectCartSubtotalForDisplay));
    this.context$ = this.store.pipe(select(selectContextData));
  }

  ngOnInit(): void {
    this.breakpointSubscription$ = this.breakpointUtils.smallScreen$.subscribe(
      isSmall => {
        this.smallScreen = isSmall;
      },
    );
  }

  ngOnDestroy(): void {
    this.breakpointSubscription$.unsubscribe();
  }

  closeCartSlide(): void {
    this.closeCart.emit();
  }

  nextStep(): void {
    this.closeCartSlide();
    this.next.emit();
  }

  requiredItemSubtitle(context: ContextData): string {
    const signup = context.signups[0];
    return `${signup.participant.firstName} ${signup.participant.lastName} • ${signup.program?.name} Signups`;
  }

  ngAfterViewChecked(): void {
    this.ref.detectChanges();
  }
}
